import { useEffect, useRef, useState } from 'react';

const useIntersectionObserver = ({
  threshold = [1],
  root = null,
  rootMargin = '0px',
  freezeOnceVisible = false,
}) => {
  const elementRef = useRef();

  const [entry, setEntry] = useState();
  const frozen = entry?.isIntersecting && freezeOnceVisible;

  const updateEntry = ([newEntry]) => {
    setEntry(newEntry);
  };

  useEffect(() => {
    const container = root;

    const cachedRef = elementRef?.current;
    const hasIOSupport = !!window.IntersectionObserver;

    if (!hasIOSupport || frozen || !cachedRef) return undefined;

    const observerParams = {
      rootMargin,
      threshold,
      root: container,
    };

    const observer = new IntersectionObserver(updateEntry, observerParams);

    observer.observe(cachedRef);

    return () => observer.unobserve(cachedRef);
  }, [elementRef?.current, JSON.stringify(threshold), root, rootMargin, frozen]);

  return [elementRef, entry];
};

export default useIntersectionObserver;
